// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__qs5kw","input":"styles_input__ExbV3"};